// File: src/pages/AdUnitsPage.tsx
import React from 'react'
import { Plus } from 'lucide-react'
// import { parseAdSettings } from '../helpers/parseAdSettings'
import { Link } from 'react-router-dom'
import { useData } from '../DataProvider'
import { CampaignUnit } from '../types/types'

const CampaignUnitList = () => {
  const { data } = useData()
  const addNewAdUnit = () => {
    // This function would typically open a modal or navigate to a new page
    console.log('Add new ad unit')
  }
  const campaignUnits: Record<string, CampaignUnit> = data?.adsSettings?.campaignUnits || {}
  const list = Object.values(campaignUnits)
    .filter((unit): unit is CampaignUnit => typeof unit === 'object' && unit !== null)
    .sort((a, b) => a.adUnit.localeCompare(b.adUnit))

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Campaign Units</h1>
        <button onClick={addNewAdUnit} style={styles.addButton}>
          <Plus size={20} />
          Add New Campaign Unit
        </button>
      </div>
      <div style={styles.list}>
        {list.map((campaignUnit) => (
          <>
            {campaignUnit.status !== 'inactive' && (
              <Link key={campaignUnit.adUnit} to={`/campaign-unit/${campaignUnit.adUnit}`} style={{ ...styles.listItem, textDecoration: 'none', color: 'inherit' }}>
                <span style={styles.adUnitName}>{campaignUnit.adUnit}</span>
                <span style={styles.adUnitAdvertiser}>{campaignUnit.status === 'inactive' ? 0 : Object.keys(campaignUnit?.placements).length} placements</span>
                <span style={styles.adUnitAdvertiser}>{campaignUnit.status}</span>
              </Link>
            )}
          </>
        ))}
      </div>
      <div style={styles.list}>
        {list.map((campaignUnit) => (
          <>
            {campaignUnit.status === 'inactive' && (
              <Link key={campaignUnit.adUnit} to={`/campaign-unit/${campaignUnit.adUnit}`} style={{ ...styles.listItem, textDecoration: 'none', color: 'inherit' }}>
                <span style={styles.adUnitName}>{campaignUnit.adUnit}</span>
                <span style={styles.adUnitAdvertiser}>{campaignUnit.status === 'inactive' ? 0 : Object.keys(campaignUnit?.placements).length} placements</span>
                <span style={styles.adUnitAdvertiser}>{campaignUnit.status}</span>
              </Link>
            )}
          </>
        ))}
      </div>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    padding: '2rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  list: {
    marginTop: '2rem',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    borderBottom: '1px solid #e5e7eb',
  },
  adUnitName: {
    flex: 1,
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  adUnitAdvertiser: {
    flex: 1,
    color: '#6b7280',
  },
  viewButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#f3f4f6',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    cursor: 'pointer',
  },
}

export default CampaignUnitList
